export default __webpack_public_path__ + "static/media/标题-专属权益.28478e2b.png";